import React from 'react';
import { Typography } from '@mui/material';
import { Adb } from '@mui/icons-material';

const Title = ({ appName, display, mobile = false }) => {
    return (
        <>
            <Adb
                sx={{
                    display: display,
                    mr: 1,
                }}
            />
            <Typography
                variant='h6'
                noWrap
                sx={{
                    mr: 2,
                    display: display,

                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                    ...(mobile === true && {
                        flexGrow: 1,
                    }),
                }}
            >
                {appName}
            </Typography>
        </>
    );
};

export default Title;
